import message from "antd/es/message";
import { getIsDarkMode } from "utils/misc";
import { getNotificationDisplayTime } from "@shared/utils/misc";
import { MessageInstance } from "antd/es/message/interface";

const useMessage = (): [MessageInstance, any] => {
  const [messageApi, contextHolder] = message.useMessage();
  const isDarkMode = getIsDarkMode();

  const messageOpen = messageApi.open;

  messageApi.open = (props) => {
    const duration =
      props.duration ||
      (typeof props.content === "string"
        ? getNotificationDisplayTime(props.content, true)
        : 8);

    return messageOpen({
      ...props,
      duration,
      className: isDarkMode ? `${props.className} dark-mode` : props.className,
    });
  };

  return [messageApi, contextHolder];
};

export default useMessage;
